import * as React from "react";
const SvgField = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", fill: "none", viewBox: "0 0 12 13", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 10.8, height: 10.8, x: 0.6, y: 1.1, stroke: "currentColor", strokeWidth: 1.2, rx: 2.4 }), /* @__PURE__ */ React.createElement("rect", { width: 2, height: 2, x: 5, y: 5.5, fill: "currentColor", rx: 1 }));
export {
  SvgField as default
};
//# sourceMappingURL=field.js.map
